var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgIo = function SvgIo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M0 0h682.67v512H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "scale(.9375)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#fff",
    d: "M0 0h1024v512H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 445.24c-11.474 6.903-21.332 23.035-51.814 23.035-60.947 0-76.188-33.965-121.9-33.965-30.474 0-45.712 33.965-76.187 33.965-60.952 0-76.191-33.965-121.9-33.965-30.477 0-45.715 33.965-76.191 33.965-60.952 0-76.191-33.965-121.9-33.965-30.477 0-45.715 33.965-76.191 33.965-60.952 0-76.191-33.965-121.9-33.965-30.478 0-45.715 33.965-76.191 33.965-60.952 0-76.192-33.965-121.91-33.965-30.476 0-39.619 24.203-57.905 24.203v43.727c18.286 0 27.428-24.2 57.905-24.2 45.715 0 60.955 33.96 121.9 33.96 30.476 0 45.713-33.965 76.191-33.965 45.713 0 60.952 33.965 121.9 33.965 30.476 0 45.714-33.965 76.191-33.965 45.714 0 60.952 33.965 121.9 33.965 30.476 0 45.714-33.965 76.191-33.965 45.714 0 60.952 33.965 121.9 33.965 30.476 0 45.714-33.965 76.187-33.965 45.715 0 60.956 33.965 121.9 33.965 30.482 0 40.34-9.625 51.814-16.528v-50.235zM1024 360.32c-11.474 6.903-21.332 23.035-51.814 23.035-60.947 0-76.188-33.965-121.9-33.965-30.474 0-45.712 33.965-76.187 33.965-60.952 0-76.191-33.965-121.9-33.965-30.477 0-45.715 33.965-76.191 33.965-60.952 0-76.191-33.965-121.9-33.965-30.477 0-45.715 33.965-76.191 33.965-60.952 0-76.191-33.965-121.9-33.965-30.478 0-45.715 33.965-76.191 33.965-60.952 0-76.192-33.965-121.91-33.965-30.476 0-39.619 24.203-57.905 24.203v43.727c18.286.01 27.428-24.2 57.905-24.2 45.714 0 60.953 33.965 121.91 33.965 30.476 0 45.713-33.965 76.191-33.965 45.713 0 60.952 33.965 121.9 33.965 30.476 0 45.714-33.965 76.191-33.965 45.714 0 60.952 33.965 121.9 33.965 30.476 0 45.714-33.965 76.191-33.965 45.714 0 60.952 33.965 121.9 33.965 30.476 0 45.714-33.965 76.187-33.965 45.715 0 60.956 33.965 121.9 33.965 30.482 0 40.34-9.625 51.814-16.528v-50.235zM1024 275.41c-11.474 6.903-21.332 23.035-51.814 23.035-60.947 0-76.188-33.965-121.9-33.965-30.474 0-45.712 33.965-76.187 33.965-60.952 0-76.191-33.965-121.9-33.965-30.477 0-45.715 33.965-76.191 33.965-60.952 0-76.191-33.965-121.9-33.965-30.477 0-45.715 33.965-76.191 33.965-60.952 0-76.191-33.965-121.9-33.965-30.478 0-45.715 33.965-76.191 33.965-60.952 0-76.192-33.965-121.91-33.965-30.476 0-39.619 24.203-57.905 24.203v43.727c18.286 0 27.428-24.2 57.905-24.2 45.714 0 60.953 33.965 121.91 33.965 30.476 0 45.713-33.965 76.191-33.965 45.713 0 60.952 33.965 121.9 33.965 30.476 0 45.714-33.965 76.191-33.965 45.714 0 60.952 33.965 121.9 33.965 30.476 0 45.714-33.965 76.191-33.965 45.714 0 60.952 33.965 121.9 33.965 30.476 0 45.714-33.965 76.187-33.965 45.715 0 60.956 33.965 121.9 33.965 30.482 0 40.34-9.625 51.814-16.528v-50.235zM1024 190.5c-11.474 6.903-21.332 23.035-51.814 23.035-60.947 0-76.188-33.965-121.9-33.965-30.474 0-45.712 33.965-76.187 33.965-60.952 0-76.191-33.965-121.9-33.965-30.477 0-45.715 33.965-76.191 33.965-60.952 0-76.191-33.965-121.9-33.965-30.477 0-45.715 33.965-76.191 33.965-60.952 0-76.191-33.965-121.9-33.965-30.478 0-45.715 33.965-76.191 33.965-60.952 0-76.192-33.965-121.91-33.965-30.476 0-39.619 24.203-57.905 24.203V247.5c18.286 0 27.428-24.2 57.905-24.2 45.714 0 60.953 33.965 121.91 33.965 30.476 0 45.713-33.965 76.191-33.965 45.713 0 60.952 33.965 121.9 33.965 30.476 0 45.714-33.965 76.191-33.965 45.714 0 60.952 33.965 121.9 33.965 30.476 0 45.714-33.965 76.191-33.965 45.714 0 60.952 33.965 121.9 33.965 30.476 0 45.714-33.965 76.187-33.965 45.715 0 60.956 33.965 121.9 33.965 30.482 0 40.34-9.625 51.814-16.528v-50.235zM1024 105.59c-11.474 6.903-21.332 23.035-51.814 23.035-60.947 0-76.188-33.965-121.9-33.965-30.474 0-45.712 33.965-76.187 33.965-60.952 0-76.191-33.965-121.9-33.965-30.477 0-45.715 33.965-76.191 33.965-60.952 0-76.191-33.965-121.9-33.965-30.477 0-45.715 33.965-76.191 33.965-60.952 0-76.191-33.965-121.9-33.965-30.478 0-45.715 33.965-76.191 33.965-60.952 0-76.192-33.965-121.91-33.965-30.491-.002-39.634 24.2-57.92 24.2v43.727c18.286 0 27.428-24.203 57.905-24.203 45.714 0 60.953 33.965 121.91 33.965 30.476 0 45.713-33.965 76.191-33.965 45.713 0 60.952 33.965 121.9 33.965 30.476 0 45.714-33.965 76.191-33.965 45.714 0 60.952 33.965 121.9 33.965 30.476 0 45.714-33.965 76.191-33.965 45.714 0 60.952 33.965 121.9 33.965 30.476 0 45.714-33.965 76.187-33.965 45.715 0 60.956 33.965 121.9 33.965 30.482 0 40.34-9.625 51.814-16.528v-50.235zM1024 20.675c-11.474 6.903-21.332 23.035-51.814 23.035-60.947 0-76.188-33.965-121.9-33.965-30.474 0-45.712 33.965-76.187 33.965-60.952 0-76.191-33.965-121.9-33.965-30.477 0-45.715 33.965-76.191 33.965-60.952 0-76.191-33.965-121.9-33.965-30.477 0-45.715 33.965-76.191 33.965-60.952 0-76.191-33.965-121.9-33.965-30.478 0-45.715 33.965-76.191 33.965-60.952 0-76.192-33.965-121.91-33.965-30.491 0-39.634 24.203-57.92 24.203v43.727c18.286 0 27.428-24.203 57.905-24.203 45.714 0 60.953 33.965 121.91 33.965 30.476 0 45.713-33.965 76.191-33.965 45.713 0 60.952 33.965 121.9 33.965 30.476 0 45.714-33.965 76.191-33.965 45.714 0 60.952 33.965 121.9 33.965 30.476 0 45.714-33.965 76.191-33.965 45.714 0 60.952 33.965 121.9 33.965 30.476 0 45.714-33.965 76.187-33.965 45.715 0 60.956 33.965 121.9 33.965 30.482 0 40.34-9.625 51.814-16.528V20.674z",
    fillRule: "evenodd",
    fill: "#000063"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#000063",
    d: "M0 .063h261.31v157.91H0z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .063v17.654L232.097 157.97h29.215v-17.654L29.215.064H0zm261.312 0v17.654L29.215 157.968H0v-17.654L232.097.064h29.215z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.88.063v157.905h43.552V.063H108.88zM0 52.698v52.635h261.312V52.698H0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 63.225v31.581h261.312v-31.58H0zM117.59.063v157.905h26.132V.063H117.59zM0 157.968l87.104-52.635h19.476l-87.104 52.635H0zM0 .063l87.104 52.635H67.628L0 11.833V.063zm154.732 52.635L241.836.063h19.476l-87.104 52.635h-19.476zm106.58 105.27l-87.104-52.635h19.476l67.628 40.866v11.77z",
    fill: "#c00"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M814.96-301.18l-17.72 708.66c0 37.298 80.097 37.298 88.583 0l-17.717-708.66h-53.149z",
    fillRule: "evenodd",
    transform: "matrix(.2064 0 0 .4902 211.633 267.436)",
    stroke: "#fff",
    strokeWidth: 6.935,
    fill: "#a24300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.06 549.21l17.717 70.866 35.433-53.15-17.717 88.583 35.433-35.433-35.433 88.582 35.433-35.433-35.433 88.583 35.433-35.433-35.433 106.3 35.433-35.433-35.433 106.3 35.433-35.433-35.433 106.3-17.716 53.151-17.717 17.72-17.717-17.72-17.716-53.151-35.433-106.3 35.433 35.433-35.433-106.3 35.433 35.433-35.433-106.3 35.433 35.433-35.433-88.583 35.433 35.433-35.433-88.582 35.433 35.433-17.717-88.583 35.433 53.15 17.717-70.866z",
    fillRule: "evenodd",
    transform: "matrix(-.2354 .06743 -.1035 -.19501 591.314 322.549)",
    stroke: "#fff",
    strokeWidth: 8.25,
    fill: "#006d00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.06 549.21v496.07M425.2 868.11l70.86 106.3 70.87-106.3",
    transform: "matrix(-.2354 .06743 -.1035 -.19501 591.314 322.549)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2 797.24l70.866 106.3 70.866-106.3",
    transform: "matrix(-.2354 .06743 -.1035 -.19501 591.314 322.549)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2 726.38l70.866 106.3 70.866-106.3",
    transform: "matrix(-.2354 .06743 -.1035 -.19501 591.314 322.549)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2 673.23l70.866 88.583 70.866-88.583",
    transform: "matrix(-.2354 .06743 -.1035 -.19501 591.314 322.549)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2 620.08l70.866 88.582 70.866-88.582",
    transform: "matrix(-.2354 .06743 -.1035 -.19501 591.314 322.549)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.91 566.93l53.15 106.3 53.15-106.3",
    transform: "matrix(-.2354 .06743 -.1035 -.19501 591.314 322.549)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M496.06 549.21l17.717 70.866 35.433-53.15-17.717 88.583 35.433-35.433-35.433 88.582 35.433-35.433-35.433 88.583 35.433-35.433-35.433 106.3 35.433-35.433-35.433 106.3 35.433-35.433-35.433 106.3-17.716 53.151-17.717 17.72-17.717-17.72-17.716-53.151-35.433-106.3 35.433 35.433-35.433-106.3 35.433 35.433-35.433-106.3 35.433 35.433-35.433-88.583 35.433 35.433-35.433-88.582 35.433 35.433-17.717-88.583 35.433 53.15 17.717-70.866z",
    fillRule: "evenodd",
    transform: "matrix(.17703 -.18126 .22077 .14638 73.835 93.526)",
    stroke: "#fff",
    strokeWidth: 8.25,
    fill: "#006d00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.06 549.21v496.07M425.2 868.11l70.86 106.3 70.87-106.3",
    transform: "matrix(.17703 -.18126 .22077 .14638 73.835 93.526)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2 797.24l70.866 106.3 70.866-106.3",
    transform: "matrix(.17703 -.18126 .22077 .14638 73.835 93.526)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2 726.38l70.866 106.3 70.866-106.3",
    transform: "matrix(.17703 -.18126 .22077 .14638 73.835 93.526)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2 673.23l70.866 88.583 70.866-88.583",
    transform: "matrix(.17703 -.18126 .22077 .14638 73.835 93.526)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2 620.08l70.866 88.582 70.866-88.582",
    transform: "matrix(.17703 -.18126 .22077 .14638 73.835 93.526)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.91 566.93l53.15 106.3 53.15-106.3",
    transform: "matrix(.17703 -.18126 .22077 .14638 73.835 93.526)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M496.06 549.21l17.717 70.866 35.433-53.15-17.717 88.583 35.433-35.433-35.433 88.582 35.433-35.433-35.433 88.583 35.433-35.433-35.433 106.3 35.433-35.433-35.433 106.3 35.433-35.433-35.433 106.3-17.716 53.151-17.717 17.72-17.717-17.72-17.716-53.151-35.433-106.3 35.433 35.433-35.433-106.3 35.433 35.433-35.433-106.3 35.433 35.433-35.433-88.583 35.433 35.433-35.433-88.582 35.433 35.433-17.717-88.583 35.433 53.15 17.717-70.866z",
    fillRule: "evenodd",
    transform: "matrix(.1135 .2156 -.24917 .1076 581.756 -57.78)",
    stroke: "#fff",
    strokeWidth: 8.25,
    fill: "#006d00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.06 549.21v496.07M425.2 868.11l70.86 106.3 70.87-106.3",
    transform: "matrix(.1135 .2156 -.24917 .1076 581.756 -57.78)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2 797.24l70.866 106.3 70.866-106.3",
    transform: "matrix(.1135 .2156 -.24917 .1076 581.756 -57.78)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2 726.38l70.866 106.3 70.866-106.3",
    transform: "matrix(.1135 .2156 -.24917 .1076 581.756 -57.78)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2 673.23l70.866 88.583 70.866-88.583",
    transform: "matrix(.1135 .2156 -.24917 .1076 581.756 -57.78)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2 620.08l70.866 88.582 70.866-88.582",
    transform: "matrix(.1135 .2156 -.24917 .1076 581.756 -57.78)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.91 566.93l53.15 106.3 53.15-106.3",
    transform: "matrix(.1135 .2156 -.24917 .1076 581.756 -57.78)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M496.06 549.21l17.717 70.866 35.433-53.15-17.717 88.583 35.433-35.433-35.433 88.582 35.433-35.433-35.433 88.583 35.433-35.433-35.433 106.3 35.433-35.433-35.433 106.3 35.433-35.433-35.433 106.3-17.716 53.151-17.717 17.72-17.717-17.72-17.716-53.151-35.433-106.3 35.433 35.433-35.433-106.3 35.433 35.433-35.433-106.3 35.433 35.433-35.433-88.583 35.433 35.433-35.433-88.582 35.433 35.433-17.717-88.583 35.433 53.15 17.717-70.866z",
    fillRule: "evenodd",
    transform: "matrix(-.15682 .19451 -.23555 -.12827 705.85 197.798)",
    stroke: "#fff",
    strokeWidth: 8.25,
    fill: "#006d00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.06 549.21v496.07M425.2 868.11l70.86 106.3 70.87-106.3",
    transform: "matrix(-.15682 .19451 -.23555 -.12827 705.85 197.798)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2 797.24l70.866 106.3 70.866-106.3",
    transform: "matrix(-.15682 .19451 -.23555 -.12827 705.85 197.798)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2 726.38l70.866 106.3 70.866-106.3",
    transform: "matrix(-.15682 .19451 -.23555 -.12827 705.85 197.798)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2 673.23l70.866 88.583 70.866-88.583",
    transform: "matrix(-.15682 .19451 -.23555 -.12827 705.85 197.798)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2 620.08l70.866 88.582 70.866-88.582",
    transform: "matrix(-.15682 .19451 -.23555 -.12827 705.85 197.798)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.91 566.93l53.15 106.3 53.15-106.3",
    transform: "matrix(-.15682 .19451 -.23555 -.12827 705.85 197.798)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M496.06 549.21l17.717 70.866 35.433-53.15-17.717 88.583 35.433-35.433-35.433 88.582 35.433-35.433-35.433 88.583 35.433-35.433-35.433 106.3 35.433-35.433-35.433 106.3 35.433-35.433-35.433 106.3-17.716 53.151-17.717 17.72-17.717-17.72-17.716-53.151-35.433-106.3 35.433 35.433-35.433-106.3 35.433 35.433-35.433-106.3 35.433 35.433-35.433-88.583 35.433 35.433-35.433-88.582 35.433 35.433-17.717-88.583 35.433 53.15 17.717-70.866z",
    fillRule: "evenodd",
    transform: "matrix(-.15547 -.16616 .17678 -.15123 275.837 396.088)",
    stroke: "#fff",
    strokeWidth: 8.25,
    fill: "#006d00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.06 549.21v496.07M425.2 868.11l70.86 106.3 70.87-106.3",
    transform: "matrix(-.15547 -.16616 .17678 -.15123 275.837 396.088)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2 797.24l70.866 106.3 70.866-106.3",
    transform: "matrix(-.15547 -.16616 .17678 -.15123 275.837 396.088)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2 726.38l70.866 106.3 70.866-106.3",
    transform: "matrix(-.15547 -.16616 .17678 -.15123 275.837 396.088)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2 673.23l70.866 88.583 70.866-88.583",
    transform: "matrix(-.15547 -.16616 .17678 -.15123 275.837 396.088)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2 620.08l70.866 88.582 70.866-88.582",
    transform: "matrix(-.15547 -.16616 .17678 -.15123 275.837 396.088)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.91 566.93l53.15 106.3 53.15-106.3",
    transform: "matrix(-.15547 -.16616 .17678 -.15123 275.837 396.088)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M460.63 549.21l28.643 70.866 42.223-53.15-10.184 88.583 27.9-35.433-17.716 88.582 25.249-35.433-25.249 88.583 35.433-35.433-35.433 106.3 35.433-35.433-35.433 106.3 35.433-35.433-35.433 106.3-17.716 53.151-17.717 17.72-17.717-17.72-17.716-53.151-35.433-106.3 35.433 35.433-35.433-106.3 35.433 35.433-35.433-106.3 35.433 35.433-45.617-88.583 45.617 35.433-53.15-88.582 42.966 35.433-25.25-88.583 35.433 53.15.001-70.866z",
    fillRule: "evenodd",
    transform: "matrix(-.27108 -.06397 -.15704 .20433 684.121 -32.23)",
    stroke: "#fff",
    strokeWidth: 8.25,
    fill: "#006d00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.21 584.65l28.855 124.02v336.62",
    transform: "matrix(-.27108 -.06397 -.15704 .20433 684.121 -32.23)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.23 885.83l59.833 88.582 60.682-88.582",
    transform: "matrix(-.27108 -.06397 -.15704 .20433 684.121 -32.23)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.53 814.96l61.53 88.582 60.682-88.582",
    transform: "matrix(-.27108 -.06397 -.15704 .20433 684.121 -32.23)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.38 744.1l60.682 88.582 59.833-88.582",
    transform: "matrix(-.27108 -.06397 -.15704 .20433 684.121 -32.23)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.84 690.94l63.228 70.866 53.149-70.866",
    transform: "matrix(-.27108 -.06397 -.15704 .20433 684.121 -32.23)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2 637.8l70.866 70.865 45.406-70.865",
    transform: "matrix(-.27108 -.06397 -.15704 .20433 684.121 -32.23)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.12 593.24l53.15 86.886 35.327-95.478",
    transform: "matrix(-.27108 -.06397 -.15704 .20433 684.121 -32.23)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M460.63 549.21l28.643 70.866 42.223-53.15-10.184 88.583 27.9-35.433-17.716 88.582 25.249-35.433-25.249 88.583 35.433-35.433-35.433 106.3 35.433-35.433-35.433 106.3 35.433-35.433-35.433 106.3-17.716 53.151-17.717 17.72-17.717-17.72-17.716-53.151-35.433-106.3 35.433 35.433-35.433-106.3 35.433 35.433-35.433-106.3 35.433 35.433-45.617-88.583 45.617 35.433-53.15-88.582 42.966 35.433-25.25-88.583 35.433 53.15.001-70.866z",
    fillRule: "evenodd",
    transform: "matrix(.27011 .06695 .00989 .24471 240.767 -138.419)",
    stroke: "#fff",
    strokeWidth: 8.25,
    fill: "#006d00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.21 584.65l28.855 124.02v336.62",
    transform: "matrix(.27011 .06695 .00989 .24471 240.767 -138.419)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.23 885.83l59.833 88.582 60.682-88.582",
    transform: "matrix(.27011 .06695 .00989 .24471 240.767 -138.419)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.53 814.96l61.53 88.582 60.682-88.582",
    transform: "matrix(.27011 .06695 .00989 .24471 240.767 -138.419)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.38 744.1l60.682 88.582 59.833-88.582",
    transform: "matrix(.27011 .06695 .00989 .24471 240.767 -138.419)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.84 690.94l63.228 70.866 53.149-70.866",
    transform: "matrix(.27011 .06695 .00989 .24471 240.767 -138.419)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2 637.8l70.866 70.865 45.406-70.865",
    transform: "matrix(.27011 .06695 .00989 .24471 240.767 -138.419)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.12 593.24l53.15 86.886 35.327-95.478",
    transform: "matrix(.27011 .06695 .00989 .24471 240.767 -138.419)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M354.33 531.5l88.583 88.583 17.716-53.149v88.582l35.433-35.433-17.716 88.583 35.432-35.434-17.716 88.584 35.433-35.433-17.716 106.3 35.433-35.433-35.433 106.3 35.433-35.433-17.717 106.3-17.716 53.151-17.717 17.72-17.717-17.72-17.716-53.151-53.15-82.294 35.434 11.429-35.433-106.3 35.433 35.433-53.15-106.3 35.433 35.433-53.15-88.584 53.15 35.434-70.866-88.583 53.149 35.433-70.866-70.866 70.866 35.433-53.149-88.583z",
    fillRule: "evenodd",
    transform: "matrix(.03453 -.23456 .24402 .04167 115.462 229.538)",
    stroke: "#fff",
    strokeWidth: 8.25,
    fill: "#006d00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.96 560.02l63.952 95.497 17.716 53.15 8.859 45.205 8.858 78.811 9.315 70.866 8.401 141.74",
    transform: "matrix(.03453 -.23456 .24402 .04167 115.462 229.538)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2 903.54l63.665 70.866 50.749-88.583",
    transform: "matrix(.03453 -.23456 .24402 .04167 115.462 229.538)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.08 814.96l70.579 88.583 50.75-88.583",
    transform: "matrix(.03453 -.23456 .24402 .04167 115.462 229.538)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.48 752.44l70.867 80.235 45.948-88.583M372.05 637.8l88.583 70.866 25.831-70.866",
    transform: "matrix(.03453 -.23456 .24402 .04167 115.462 229.538)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.62 602.36l82.296 53.149 10.515-53.149M389.76 690.94l81.095 70.866 33.946-70.866",
    transform: "matrix(.03453 -.23456 .24402 .04167 115.462 229.538)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M541.46 1173.3l-1.7-229.13-61.1-106.94c-15.277-52.618-7.754-78.079 16.973-79.776 24.728-1.698 49.224 13.579 84.868 15.276 35.645 1.697 28.856-59.408 81.474-57.71 52.618 1.697 144.28 32.25 222.36 37.342 78.078 5.092 118.81-27.158 208.77-30.553 89.97-3.395 113.73 42.435 118.82 42.435s30.55-18.672 56.01-22.066c25.46-3.395 33.95 10.184 33.95 10.184s-1.7 57.71-13.58 91.657c-11.88 33.948-54.32 89.961-56.01 89.961-1.7 0-15.28 249.52-15.28 251.21 0 1.7-675.55-6.79-675.55-11.88z",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#c00",
    transform: "matrix(.13659 0 0 .12573 266.36 208.19)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.5 584.65s-67.982-52.097-69.813-177.17c-1.053-71.929 34.38-124.02 122.96-124.02 124.02 0 301.18 53.149 301.18 53.149v17.717s-141.73-53.15-301.18-53.15c-70.866 0-106.3 52.087-106.3 105.24 0 88.583 70.867 178.23 70.867 178.23v141.73h-17.717v-141.73z",
    fill: "#fff100",
    transform: "matrix(-.13659 0 0 .12573 508.357 252.74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(-.13659 0 0 .12573 506.168 252.526)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(-.13659 0 0 .12573 508.588 247.431)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(-.13659 0 0 .12573 509.849 242.243)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(-.13659 0 0 .12573 510.776 236.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(-.13659 0 0 .12573 510.545 230.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(-.13659 0 0 .12573 502.69 257.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(-.13659 0 0 .12573 508.487 224.996)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(-.13659 0 0 .12573 504.082 220.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(-.13659 0 0 .12573 498.054 217.528)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(-.13659 0 0 .12573 492.026 217.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(-.13659 0 0 .12573 485.535 217.314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(-.13659 0 0 .12573 479.043 218.168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(-.13659 0 0 .12573 472.55 219.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(-.13659 0 0 .12573 465.596 220.088)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(-.13659 0 0 .12573 459.568 221.583)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(.13659 0 0 .12573 268.548 252.526)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(.13659 0 0 .12573 266.128 247.432)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(.13659 0 0 .12573 264.867 242.243)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(.13659 0 0 .12573 263.94 236.694)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(.13659 0 0 .12573 264.172 230.678)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(.13659 0 0 .12573 266.23 224.996)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(.13659 0 0 .12573 270.635 220.515)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(.13659 0 0 .12573 276.662 217.527)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(.13659 0 0 .12573 282.69 217.1)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(.13659 0 0 .12573 289.181 217.314)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(.13659 0 0 .12573 295.674 218.168)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(.13659 0 0 .12573 302.166 219.021)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(.13659 0 0 .12573 309.12 220.088)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(.13659 0 0 .12573 315.149 221.583)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(.13659 0 0 .12573 272.026 257.008)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.5 584.65s-67.982-52.097-69.813-177.17c-1.053-71.929 34.38-124.02 122.96-124.02 124.02 0 301.18 53.149 301.18 53.149v17.717s-141.73-53.15-301.18-53.15c-70.866 0-106.3 52.087-106.3 105.24 0 88.583 70.867 178.23 70.867 178.23v141.73h-17.717v-141.73z",
    transform: "matrix(.13659 0 0 .12573 266.36 252.74)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.2 531.5s15.35-35.433 70.86-35.433c37.79 0 70.87 35.433 70.87 70.866v70.866h35.43v-70.866c0-35.47 35.44-70.866 70.87-70.866 53.15 0 70.87 35.433 70.87 35.433s0-106.3-70.87-106.3c-53.15 0-70.87 35.433-70.87 35.433s17.72-53.15 17.72-106.3-35.43-88.583-35.43-88.583c0 6.79-35.44 35.433-35.44 88.583 0 53.149 17.72 106.3 17.72 106.3s-17.72-35.433-70.87-35.433c-70.86 0-70.86 106.3-70.86 106.3z",
    transform: "matrix(.04553 0 0 .0479 299.433 309.064)",
    stroke: "#000",
    strokeWidth: 2.991,
    fill: "#fff100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.2 531.5s15.35-35.433 70.86-35.433c37.79 0 70.87 35.433 70.87 70.866v70.866h35.43v-70.866c0-35.47 35.44-70.866 70.87-70.866 53.15 0 70.87 35.433 70.87 35.433s0-106.3-70.87-106.3c-53.15 0-70.87 35.433-70.87 35.433s17.72-53.15 17.72-106.3-35.43-88.583-35.43-88.583c0 6.79-35.44 35.433-35.44 88.583 0 53.149 17.72 106.3 17.72 106.3s-17.72-35.433-70.87-35.433c-70.86 0-70.86 106.3-70.86 106.3z",
    transform: "matrix(.04553 0 0 .0479 347.83 309.064)",
    stroke: "#000",
    strokeWidth: 2.991,
    fill: "#fff100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.5 832.68V673.23s35.433 53.15 88.583 53.15c43.489 0 88.582-70.866 88.582-70.866s41.515 53.149 88.583 53.149c42.021 0 88.516-68.572 88.516-68.572s43.207 68.572 88.649 68.572c45.441 0 88.581-53.149 88.581-53.149s46.29 70.866 106.3 70.866c53.15 0 70.87-53.15 70.87-53.15v159.45h-708.66z",
    transform: "matrix(.13659 0 0 .12573 266.36 252.74)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.66 832.68V708.66s106.3 35.433 106.3 124.02h-106.3z",
    transform: "matrix(.13659 0 0 .12573 242.16 252.74)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.66 832.68V708.66s106.3 35.433 106.3 124.02h-106.3z",
    transform: "matrix(-.13659 0 0 .12573 532.547 252.74)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.36 832.68c0-88.583 106.37-144.6 106.37-144.6s106.23 56.016 106.23 144.6h-212.6z",
    transform: "matrix(.13659 0 0 .12573 266.36 252.74)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.36 832.68c0-88.583 106.37-144.6 106.37-144.6s106.23 56.016 106.23 144.6h-212.6z",
    transform: "matrix(.13659 0 0 .12573 314.758 252.74)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.65 847.53c0-88.583 124.08-159.45 124.08-159.45s123.95 70.866 123.95 159.45H584.65z",
    transform: "matrix(.13659 0 0 .12573 290.558 250.873)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.6 655.51c-35.43-17.716-166.02-35.433-376.28-35.433s-350.1 17.717-385.53 35.433c-35.434 17.717-35.434 53.149-.001 70.866 35.433 17.716 175.28 35.433 385.54 35.433s340.84-17.716 376.28-35.433c35.43-17.716 35.43-53.149 0-70.866z",
    transform: "matrix(.13505 0 0 .12573 265.898 275.015)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.757 366.342c0 4.455-40.256 4.455-48.399 4.455-8.797 0-48.398 1.207-48.398-4.455 0-4.455 39.928-4.455 48.398-4.455 8.47 0 48.399.906 48.399 4.455z",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.797 350.342c0 1.456-1.084 2.636-2.42 2.636-1.337 0-2.42-1.18-2.42-2.636s1.083-2.637 2.42-2.637c1.336 0 2.42 1.18 2.42 2.637zM435.753 350.342c0 1.456-1.083 2.636-2.42 2.636-1.336 0-2.42-1.18-2.42-2.636s1.084-2.637 2.42-2.637c1.337 0 2.42 1.18 2.42 2.637z",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.195 348.932c0 1.456-2.167 2.636-4.84 2.636s-4.84-1.18-4.84-2.636 2.167-2.636 4.84-2.636 4.84 1.18 4.84 2.636z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.41 348.932c0 1.456-1.625 2.636-3.63 2.636-2.004 0-3.63-1.18-3.63-2.636s1.626-2.636 3.63-2.636c2.005 0 3.63 1.18 3.63 2.636zM365.576 348.932c0 1.456-1.626 2.636-3.63 2.636-2.005 0-3.63-1.18-3.63-2.636s1.625-2.636 3.63-2.636c2.004 0 3.63 1.18 3.63 2.636z",
    fill: "#006300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1257.9 496.06s35.44-53.15 70.87-53.15h35.43v35.433c0 53.15-53.15 70.867-53.15 70.867h141.74s-53.15-17.717-53.15-70.867V442.91h35.43c35.43 0 70.87 53.15 70.87 53.15V354.33s-35.44 53.15-70.87 53.15h-35.43v-35.433c0-53.15 53.15-70.867 53.15-70.867h-141.74s53.15 17.717 53.15 70.867v35.433h-35.43c-35.43 0-70.87-53.15-70.87-53.15v141.73z",
    transform: "matrix(.07805 0 0 .07185 279.5 297.926)",
    stroke: "#000",
    strokeWidth: 2.188,
    fill: "#fff100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.9 549.21l70.87.001s-53.15-17.717-53.15-70.867v-35.433h35.43c35.43 0 70.87 53.15 70.87 53.15v-141.73s-35.44 53.15-70.87 53.15h-35.43v-35.433c0-53.15 53.15-70.867 53.15-70.867h-70.87v248.03z",
    transform: "matrix(.03903 0 0 .06287 285.03 307.314)",
    stroke: "#000",
    strokeWidth: 3.307,
    fill: "#fff100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.9 549.21l70.87.001s-53.15-17.717-53.15-70.867v-35.433h35.43c35.43 0 70.87 53.15 70.87 53.15v-141.73s-35.44 53.15-70.87 53.15h-35.43v-35.433c0-53.15 53.15-70.867 53.15-70.867h-70.87v248.03z",
    transform: "matrix(-.03903 0 0 .06287 489.685 307.314)",
    stroke: "#000",
    strokeWidth: 3.307,
    fill: "#fff100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.54 602.36c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(.13659 0 0 .12573 266.36 252.74)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1257.9 496.06s35.44-53.15 70.87-53.15h35.43v35.433c0 53.15-53.15 70.867-53.15 70.867h141.74s-53.15-17.717-53.15-70.867V442.91h35.43c35.43 0 70.87 53.15 70.87 53.15V354.33s-35.44 53.15-70.87 53.15h-35.43v-35.433c0-53.15 53.15-70.867 53.15-70.867h-141.74s53.15 17.717 53.15 70.867v35.433h-35.43c-35.43 0-70.87-53.15-70.87-53.15v141.73z",
    transform: "matrix(.07805 0 0 .07185 279.5 251.15)",
    stroke: "#000",
    strokeWidth: 2.188,
    fill: "#fff100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.54 602.36c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(.13659 0 0 .12573 266.592 206.336)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff100",
    d: "M850.39 655.51h70.866v53.15H850.39z",
    transform: "matrix(.13659 0 0 .12573 266.36 208.19)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff100",
    d: "M850.39 683.3h70.866v202.53H850.39z",
    transform: "matrix(.13659 0 0 .12573 266.36 208.19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(.13659 0 0 .12573 324.438 246.057)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(.13659 0 0 .12573 324.438 240.295)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(.13659 0 0 .12573 324.438 234.92)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.35 549.21c0 9.785-7.932 17.717-17.717 17.717-9.785 0-17.717-7.932-17.717-17.717 0-9.785 7.932-17.717 17.717-17.717 9.785 0 17.717 7.932 17.717 17.717z",
    transform: "matrix(.13659 0 0 .12573 324.438 229.372)",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.495 357.482c0 1-2.202 1.81-4.918 1.81s-4.918-.81-4.918-1.81 2.202-1.811 4.918-1.811c2.717 0 4.918.81 4.918 1.81zM437.065 361.903c-.272.685-2.668.742-5.35.127-2.683-.615-4.638-1.67-4.366-2.355.273-.686 2.668-.743 5.35-.128 2.684.616 4.638 1.67 4.366 2.356zM418.437 358.899c-.108.882-2.439 1.44-5.206 1.247-2.768-.194-4.925-1.065-4.817-1.947.108-.882 2.439-1.44 5.206-1.247 2.768.193 4.925 1.065 4.817 1.947zM336.567 361.903c.272.685 2.668.742 5.35.127 2.683-.615 4.638-1.67 4.366-2.355-.273-.686-2.668-.743-5.35-.128-2.684.616-4.638 1.67-4.366 2.356zM356.128 358.472c.108.882 2.439 1.44 5.206 1.247 2.768-.193 4.925-1.065 4.817-1.947-.108-.882-2.439-1.44-5.207-1.247-2.767.193-4.924 1.065-4.816 1.947z"
  })))));
};
export default __webpack_public_path__ + "assets/54068f3db94d7bdd8da2ea6e2e01917f.svg";
export { SvgIo as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/io.svg